import { DOWNLOAD_IMAGES } from '../../../../constants/apiRoutes';
import { ApiError } from '../../../../types/Content';
import { httpClient } from '../../../../utils/httpClient';
import Logger from '../../../../utils/logger';
import { ApiPayloadUsed } from '../../stateSegments/brandsInformationStateSegment';

type ImagesDownload = {
  brand: string;
  url: string;
  status?: 'INITIATED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  eventId?: string;
};

export type DownloadImagesResponse = {
  success: boolean;
  data: {
    imagesDownload: ImagesDownload[];
    eventId?: string;
  };
};

export const downloadAllImages = async (
  apiPayload: ApiPayloadUsed
): Promise<DownloadImagesResponse> => {
  const {
    brand: brandName,
    country: countryName,
    indication: indicationName,
    targetAudience,
    aemAssetIntegrationEnabled,
    eventId,
  } = apiPayload;
  try {
    const params: {
      countryName: string;
      brandName: string;
      indicationName: string;
      audienceNames?: string[];
      eventId?: string;
    } = {
      countryName,
      brandName,
      indicationName: indicationName || 'ANY',
    };

    // Only pass audienceNames if aem-asset-integration is enabled
    if (aemAssetIntegrationEnabled) {
      params.audienceNames = targetAudience?.filter(
        (audience): audience is string => audience !== undefined
      );
    }

    // Pass eventId if provided (for subsequent polling requests)
    if (eventId) {
      params.eventId = eventId;
    }

    const response = await httpClient.get<DownloadImagesResponse>(
      DOWNLOAD_IMAGES(params)
    );
    const { data, success } = response as DownloadImagesResponse;

    if (success && data) {
      return {
        success: true,
        data,
      };
    }
    return {
      data: {
        imagesDownload: [
          {
            brand: '',
            url: '',
          },
        ],
      },
      success: false,
    };
  } catch (error) {
    const postError = error as ApiError;
    Logger.error(new Error(postError.message));
    return {
      success: false,
      data: {
        imagesDownload: [
          {
            brand: '',
            url: '',
          },
        ],
      },
    };
  }
};
